"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentSplitterContractDeployDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const shares_1 = require("./shares");
const validation_1 = require("./validation");
const PaymentSplitterContractDeployDialog = (props) => {
    return ((0, jsx_runtime_1.jsx)(mui_dialog_form_1.FormDialog, { initialValues: shares_1.emptyShare, validationSchema: validation_1.validationSchema, message: "dialogs.deploy", testId: "PonziContractDeployForm", ...props, children: (0, jsx_runtime_1.jsx)(shares_1.SharesInput, {}) }));
};
exports.PaymentSplitterContractDeployDialog = PaymentSplitterContractDeployDialog;
//# sourceMappingURL=index.js.map